// Brighter Land International School (BLIS) & Brighter Land Global Mission
// Comprehensive Gallery, Historical Evolution & Impact Data Records

export const galleryCategories = [
  { id: "all", name: "All Gallery", icon: "fas fa-th-large", count: 92 },
  { id: "evolution", name: "Campus Building Evolution", icon: "fas fa-building", count: 15 },
  { id: "partners", name: "Rev. Dr. Jea Chan Lee & Sun Ann", icon: "fas fa-hand-holding-heart", count: 11 },
  { id: "zoo", name: "Jos Zoo & Wildlife Safaris", icon: "fas fa-paw", count: 14 },
  { id: "airport", name: "Jos Airport Visit", icon: "fas fa-plane-departure", count: 7 },
  { id: "museum", name: "Jos Museum Tour", icon: "fas fa-landmark", count: 3 },
  { id: "supporter", name: "USA Supporter Visit", icon: "fas fa-globe-americas", count: 5 },
  { id: "scholarship", name: "Scholarship Grants", icon: "fas fa-graduation-cap", count: 7 },
  { id: "bags", name: "School Bags Outreach", icon: "fas fa-shopping-bag", count: 10 },
  { id: "borehole", name: "Clean Water Boreholes", icon: "fas fa-tint", count: 6 },
  { id: "sports", name: "Sports & Trophy Winners", icon: "fas fa-trophy", count: 6 },
  { id: "donations", name: "School Relief Donations", icon: "fas fa-hands-helping", count: 5 },
  { id: "academics", name: "Conducive Classrooms", icon: "fas fa-chalkboard-teacher", count: 3 },
]

export const galleryItems = [
  // -------------------------------------------------------------
  // 1. CAMPUS BUILDING EVOLUTION ("From Nothing to Something")
  // -------------------------------------------------------------
  {
    id: "evo-land-1",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "How the Land Was: Original Site & Landscape",
    categoryLabel: "Campus Evolution",
    image: "/images/more/how the land was.jpeg",
    location: "Gura-Suga, Jos",
    date: "Genesis Phase",
    description: "The original site at Gura-Suga, Jos showing the raw ground and old community buildings before development began.",
    featured: true,
  },
  {
    id: "evo-land-2",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "How the Land Was: Land Survey & Terrain",
    categoryLabel: "Campus Evolution",
    image: "/images/more/how the land was2.jpeg",
    location: "Gura-Suga, Jos",
    date: "Genesis Phase",
    description: "Initial overview of the land and terrain before foundation excavation and site clearing.",
    featured: false,
  },
  {
    id: "evo-land-3",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "How the Land Was: Open Land View",
    categoryLabel: "Campus Evolution",
    image: "/images/more/how the land was3.jpeg",
    location: "Gura-Suga, Jos",
    date: "Genesis Phase",
    description: "Bare ground and open space showing the early layout of the land prior to building works.",
    featured: false,
  },
  {
    id: "evo-land-4",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "How the Land Was: Site with Surrounding Old Buildings",
    categoryLabel: "Campus Evolution",
    image: "/images/more/how the land was4.jpeg",
    location: "Gura-Suga, Jos",
    date: "Genesis Phase",
    description: "View of the land showing the original layout and surrounding old community buildings before building began.",
    featured: false,
  },
  {
    id: "evo-1",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Digging Foundation Trenches",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school buiding.jpeg",
    location: "Gura-Suga, Jos",
    date: "Foundation Phase",
    description: "Excavating the initial foundation trenches in the soil for the classroom block.",
    featured: true,
  },
  {
    id: "evo-2",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Foundation Holes & Groundwork",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building2.jpeg",
    location: "Gura-Suga, Jos",
    date: "Foundation Phase",
    description: "Deep foundation holes and trenches dug into the earth for the classroom foundation.",
    featured: false,
  },
  {
    id: "evo-3",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Inspecting Foundation Holes",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building3.jpeg",
    location: "Gura-Suga, Jos",
    date: "Foundation Phase",
    description: "Inspecting the excavated foundation holes and ground depth for the classroom structure.",
    featured: false,
  },
  {
    id: "evo-4",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Foundation with Blocks",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building4.jpeg",
    location: "Gura-Suga, Jos",
    date: "Foundation Phase",
    description: "Laying the first courses of foundation blocks inside the trenches with staged cement blocks on site.",
    featured: false,
  },
  {
    id: "evo-5",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Raising Walls (3–4 Block Courses)",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building5.jpeg",
    location: "Gura-Suga, Jos",
    date: "Construction Phase",
    description: "Raising the classroom wall blocks about 3 to 4 courses above the foundation level.",
    featured: false,
  },
  {
    id: "evo-6",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Wall Construction to Lintel Level",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school buiding6.jpeg",
    location: "Gura-Suga, Jos",
    date: "Construction Phase",
    description: "Block work progressing up to the lintel level across the classroom rows.",
    featured: false,
  },
  {
    id: "evo-7",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Roofing Structure & Timber Trusses",
    categoryLabel: "Campus Evolution",
    image: "/images/more/schoolbuilding7.jpeg",
    location: "Gura-Suga, Jos",
    date: "Roofing Phase",
    description: "Installation of the wooden roof trusses and roofing framework over the classroom block.",
    featured: false,
  },
  {
    id: "evo-8",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Roofed Building (Unplastered & Unpainted)",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building8.jpeg",
    location: "Gura-Suga, Jos",
    date: "Roofing Phase",
    description: "Classroom block with zinc roofing installed, awaiting exterior plastering and painting.",
    featured: false,
  },
  {
    id: "evo-9",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "One-Side Classroom Block (Roofed & Unpainted)",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building9.jpeg",
    location: "Gura-Suga, Jos",
    date: "Building Progress",
    description: "One side of the new classroom block roofed on raw ground alongside the old building, unpainted.",
    featured: true,
  },
  {
    id: "evo-10",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Floored Classroom Wing & Site Grounds",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building10.jpeg",
    location: "Gura-Suga, Jos",
    date: "Flooring Phase",
    description: "View of the classroom block with internal flooring completed, showing the surrounding compound and older buildings.",
    featured: false,
  },
  {
    id: "evo-11",
    type: "image",
    category: "evolution",
    group: "evolution",
    title: "Floored Classrooms & Compound View",
    categoryLabel: "Campus Evolution",
    image: "/images/more/school building11.jpeg",
    location: "Gura-Suga, Jos",
    date: "Flooring Phase",
    description: "View of classrooms with completed flooring, with the old buildings still situated on the grounds.",
    featured: true,
  },

  // -------------------------------------------------------------
  // 2. INTERNATIONAL BENEFACTORS & SPONSORS (Rev. Dr. Jea Chan Lee & Sun Ann)
  // -------------------------------------------------------------
  {
    id: "part-1",
    type: "image",
    category: "partners",
    group: "partners",
    title: "International Sponsoring Partners & Benefactors",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/sponsor Rev Dr Jea Chan Lee & Sun Ann.jpeg",
    location: "BLIS Campus, Jos",
    date: "Mission Partnership",
    description: "Rev. Dr. Jea Chan Lee and Sun Ann, international supporters and mission partners, visiting BLIS to provide vital scholarships and educational support.",
    featured: true,
  },
  {
    id: "part-2",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Strategic Educational Partnership with Founder",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/proprietor with Rev Dr Jea Chan Lee & Sun Ann.jpeg",
    location: "BLIS Executive Suite",
    date: "Mission Partnership",
    description: "Rev. Fidelis Gambo in strategic fellowship and planning with Rev. Dr. Jea Chan Lee & Sun Ann for expanding scholarship programs for orphans and missionary children.",
    featured: true,
  },
  {
    id: "part-3",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Official Scholarship Award Presentation",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/scholarship by Rev Dr Jea Chan Lee & Sun Ann.jpeg",
    location: "BLIS Main Hall",
    date: "Scholarship Ceremony",
    description: "Presentation of educational scholarship grants directly to beneficiary scholars, covering tuition, books, and essential school requirements.",
    featured: true,
  },
  {
    id: "part-4",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Empowering Underprivileged Scholars with Grants",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/scholarship by Rev Dr Jea Chan Lee & Sun Ann2.jpeg",
    location: "BLIS Campus",
    date: "Scholarship Ceremony",
    description: "Beneficiary students receiving official scholarship packages, unlocking access to quality Christian and international standard education.",
    featured: false,
  },
  {
    id: "part-5",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Classroom Interaction with Scholars",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/Rev Dr Jea Chan Lee & Sun Ann in class with students.jpeg",
    location: "Primary Classroom",
    date: "Classroom Visit",
    description: "Rev. Dr. Jea Chan Lee and Sun Ann interacting closely with pupils in the classroom, sharing words of wisdom and divine purpose.",
    featured: true,
  },
  {
    id: "part-6",
    type: "image",
    category: "partners",
    group: "partners",
    title: "International Sponsor Classroom Mentorship",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/Rev Dr Jea Chan Lee and the students in class.jpeg",
    location: "Secondary Classroom",
    date: "Classroom Visit",
    description: "Inspiring scholars with global perspectives, motivating them to study with diligence and integrity.",
    featured: false,
  },
  {
    id: "part-7",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Warm Scholar Fellowship with International Supporter",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/Rev Dr Jea Chan Lee with students.jpeg",
    location: "BLIS Courtyard",
    date: "Classroom Visit",
    description: "Pupils joyfully gathering around Rev. Dr. Jea Chan Lee, demonstrating the warm international relationship between BLIS and global benefactors.",
    featured: false,
  },
  {
    id: "part-8",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Sponsoring Benefactors with School Leadership",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/sponsorship givers and the school management.jpeg",
    location: "BLIS Administrative Wing",
    date: "Management Meeting",
    description: "Management and international benefactors uniting in prayer and thanksgiving for the continued growth of Brighter Land International School.",
    featured: false,
  },
  {
    id: "part-9",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Strategic Meeting with Sponsoring Delegation",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/sponsors and school management2.jpeg",
    location: "BLIS Staff Room",
    date: "Management Meeting",
    description: "School directors, teachers, and management team meeting with the sponsoring delegation to review academic milestones.",
    featured: false,
  },
  {
    id: "part-10",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Sponsors Observing Active Classroom Pedagogy",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/sponsors in class with students.jpeg",
    location: "Primary Learning Block",
    date: "Classroom Visit",
    description: "Witnessing first-hand the daily academic diligence, moral discipline, and intellectual transformation of students at BLIS.",
    featured: false,
  },
  {
    id: "part-11",
    type: "image",
    category: "partners",
    group: "partners",
    title: "Beneficiary Students with International Sponsors",
    categoryLabel: "Rev. Dr. Jea Chan Lee & Sun Ann",
    image: "/images/more/sponsors nd students.jpeg",
    location: "BLIS Campus",
    date: "Scholarship Impact",
    description: "Heartwarming group portrait of scholars sponsored through international partner benevolence.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 3. COMMUNITY SCHOOL BAGS OUTREACH (BLGM)
  // -------------------------------------------------------------
  {
    id: "bags-0",
    type: "image",
    category: "bags",
    group: "mission",
    title: "School Bags & Supplies Distribution to Pupils",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags.jpeg",
    location: "Community Primary Outreach, Jos",
    date: "BLGM Educational Relief",
    description: "Rev. Fidelis Gambo, BLGM team, and partners distributing sturdy school bags, writing materials, and educational kits to eager children.",
    featured: true,
  },
  {
    id: "bags-1",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Joyful Scholars Receiving Brand-New Backpacks",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags1.jpeg",
    location: "Rural Community Mission Field",
    date: "BLGM Educational Relief",
    description: "Empowering children from vulnerable families with the necessary school essentials to attend classes with dignity and joy.",
    featured: false,
  },
  {
    id: "bags-2",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Equipping Vulnerable Children for School",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags2.jpeg",
    location: "Gura-Suga & Surrounding Settlements",
    date: "BLGM Educational Relief",
    description: "Ensuring that no child is kept away from learning due to a lack of school bags, stationery, or basic educational materials.",
    featured: false,
  },
  {
    id: "bags-3",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Mission Outreach Assembly & Bag Presentation",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags3.jpeg",
    location: "Mission Field Assembly",
    date: "BLGM Educational Relief",
    description: "Gathering community children for words of encouragement, prayers, and personal distribution of customized school bags.",
    featured: false,
  },
  {
    id: "bags-4",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Smiles of Gratitude from Beneficiary Children",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags4.jpeg",
    location: "Community Relief Mission",
    date: "BLGM Educational Relief",
    description: "Children proudly showing their new backpacks, inspired to pursue academic excellence despite economic hardships.",
    featured: false,
  },
  {
    id: "bags-5",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Hands-on Care by Mission Leaders & Volunteers",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags5.jpeg",
    location: "BLGM Outreach Center",
    date: "BLGM Educational Relief",
    description: "Volunteers and educators personally fitting backpacks and handing out stationery kits to each pupil.",
    featured: false,
  },
  {
    id: "bags-6",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Empowering Young Girls with Learning Supplies",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags6.jpeg",
    location: "Grassroots Educational Support",
    date: "BLGM Educational Relief",
    description: "Special outreach targeting young girls in underserved areas to champion girl-child education and literacy.",
    featured: false,
  },
  {
    id: "bags-7",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Community Elders & Parents Appreciating Support",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags7.jpeg",
    location: "Community Outreach Ground",
    date: "BLGM Educational Relief",
    description: "Parents and community leaders thanking Brighter Land Global Mission for continuous educational relief.",
    featured: false,
  },
  {
    id: "bags-8",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Large-Scale Educational Material Relief",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags8.jpeg",
    location: "Plateau State Mission Outreach",
    date: "BLGM Educational Relief",
    description: "Hundreds of school bags and notebooks organized for systematic distribution across several conflict-affected clusters.",
    featured: true,
  },
  {
    id: "bags-9",
    type: "image",
    category: "bags",
    group: "mission",
    title: "Inspiring the Next Generation of Global Leaders",
    categoryLabel: "School Bags Outreach",
    image: "/images/more/sharing of school bags9.jpeg",
    location: "Community Youth Outreach",
    date: "BLGM Educational Relief",
    description: "Lifting burdens off struggling parents and inspiring children to study hard and make positive societal impact.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 4. SPORTS, GAMES & TROPHY WINNERS
  // -------------------------------------------------------------
  {
    id: "sport-1",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Inter-House Sports Champions Celebrating Victory",
    categoryLabel: "Sports & Athletics",
    image: "/images/more/trophy winners in sport activity.jpeg",
    location: "BLIS Sports Pavilion",
    date: "Inter-House Sports",
    description: "Proud scholars hoisting trophies after displaying exceptional teamwork, speed, and sportsmanship during inter-house athletics.",
    featured: true,
  },
  {
    id: "sport-2",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Trophy Presentation to Best Athlete",
    categoryLabel: "Sports & Athletics",
    image: "/images/more/trophy winner insports activity.jpeg",
    location: "BLIS Athletic Field",
    date: "Inter-House Sports",
    description: "Recognizing outstanding individual track and field performances with commemorative cups and awards.",
    featured: false,
  },
  {
    id: "sport-3",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Junior Division Sports Distinction",
    categoryLabel: "Sports & Athletics",
    image: "/images/more/trophy winner in sport activity.jpeg",
    location: "BLIS Sports Grounds",
    date: "Athletics Festival",
    description: "Encouraging sportsmanship, physical resilience, and healthy competitive spirit from the early years.",
    featured: false,
  },
  {
    id: "sport-4",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Track, Field & Outdoor Athletic Drills",
    categoryLabel: "Sports & Athletics",
    image: "/images/more/sports activity.jpeg",
    location: "BLIS Sports Pitch",
    date: "Physical Education",
    description: "Weekly physical education, aerobics, sprint drills, and team games building stamina and mental sharpness.",
    featured: false,
  },
  {
    id: "sport-5",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Recreational Games & Scholar Bonding",
    categoryLabel: "Sports & Athletics",
    image: "/images/more/games.jpeg",
    location: "School Yard",
    date: "Student Life",
    description: "Wholesome outdoor games and camaraderie nurturing lifelong friendships and leadership skills.",
    featured: false,
  },
  {
    id: "sport-6",
    type: "image",
    category: "sports",
    group: "campus",
    title: "Extracurricular Team Athletics & Wellness",
    categoryLabel: "Sports & Athletics",
    image: "/images/gallery/games1.jpeg",
    location: "BLIS Sports Grounds",
    date: "Student Life",
    description: "Fostering physical wellness, sportsmanship, and leadership through lively athletic games and team competitions.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 5. WILDLIFE & ZOO EXCURSIONS
  // -------------------------------------------------------------
  {
    id: "zoo-1",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Jos Wildlife Park & Zoo Excursion",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo1.jpeg",
    location: "Jos Wildlife Park, Plateau State",
    date: "Academic Field Excursion",
    description: "BLIS scholars embarking on an experiential field expedition to explore biodiversity, animal science, and natural conservation at the Jos Wildlife Park.",
    featured: true,
  },
  {
    id: "zoo-2",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Guided Nature & Wildlife Observation",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo2.jpeg",
    location: "Jos Zoo, Plateau State",
    date: "Academic Field Excursion",
    description: "Students observing diverse wildlife exhibits, learning about biological taxonomy and the preservation of indigenous Nigerian ecosystems.",
    featured: false,
  },
  {
    id: "wild-1",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Close Encounter with Elephant at Wildlife Sanctuary",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife with elephant.jpeg",
    location: "Jos Wildlife Park",
    date: "Field Safari",
    description: "Scholars marveling at the African elephant during a guided ecological study tour on wildlife habitats.",
    featured: true,
  },
  {
    id: "wild-2",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Exploring African Wildlife & Conservation",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife.jpeg",
    location: "Wildlife Conservation Park",
    date: "Field Safari",
    description: "Interactive outdoor nature lesson on species conservation, ecology, and environmental stewardship.",
    featured: false,
  },
  {
    id: "wild-3",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Scholars Observing Wildlife in Natural Habitats",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife escosion.jpeg",
    location: "Plateau Nature Reserve",
    date: "Nature Trail",
    description: "Engaging students with live observations of indigenous fauna and flora in protected natural surroundings.",
    featured: false,
  },
  {
    id: "wild-4",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Nature Trail Expedition & Environmental Study",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife escosion2.jpeg",
    location: "Jos Wildlife Sanctuary",
    date: "Nature Trail",
    description: "Scholars navigating scenic conservation walkways while recording scientific field notes.",
    featured: false,
  },
  {
    id: "wild-5",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Biodiversity Discovery & Field Zoology",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife escosion3.jpeg",
    location: "Jos Wildlife Grounds",
    date: "Field Safari",
    description: "Experiential learning helping students connect textbook biology with real-world animal behavior.",
    featured: false,
  },
  {
    id: "wild-6",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Wildlife Park Excursion Guided Group Tour",
    categoryLabel: "Wildlife Safari",
    image: "/images/more/wildlife escossion.jpeg",
    location: "Plateau Wildlife Reserve",
    date: "Excursion Tour",
    description: "Group photo of educators and scholars during their memorable ecological expedition.",
    featured: false,
  },
  {
    id: "zoo-5",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Learning Beyond the Four Classroom Walls",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo5.jpeg",
    location: "Jos Wildlife Park",
    date: "Academic Field Excursion",
    description: "Experiential learning fosters deeper curiosity and broadens intellectual horizons for young minds.",
    featured: false,
  },
  {
    id: "zoo-6",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Fauna & Flora Botanical Trail Walk",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo6.jpeg",
    location: "Jos Wildlife Sanctuary",
    date: "Academic Field Excursion",
    description: "Walking the scenic conservation trails while taking scientific notes and discussing environmental stewardship.",
    featured: false,
  },
  {
    id: "zoo-7",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Zoological Exploration & Student Engagement",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo7.jpeg",
    location: "Jos Wildlife Park",
    date: "Academic Field Excursion",
    description: "Young scholars interacting with educators on wildlife protection and veterinary conservation principles.",
    featured: false,
  },
  {
    id: "zoo-8",
    type: "image",
    category: "zoo",
    group: "excursions",
    title: "Field Trip Reflections & Science Discovery",
    categoryLabel: "Jos Zoo Visit",
    image: "/images/gallery/zoo8.jpeg",
    location: "Jos Wildlife Park",
    date: "Academic Field Excursion",
    description: "Reflective group sessions reinforcing lessons in biology, geography, and environmental stewardship.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 6. JOS NATIONAL MUSEUM TOUR
  // -------------------------------------------------------------
  {
    id: "mus-1",
    type: "image",
    category: "museum",
    group: "excursions",
    title: "Earliest Cars in Nigeria Exhibition",
    categoryLabel: "Jos Museum Tour",
    image: "/images/gallery/zoo3.jpeg",
    location: "National Museum Jos / Vintage Vehicles",
    date: "Cultural Heritage Tour",
    description: "BLIS scholars viewing the historic exhibition of some of the earliest motorcars and vintage automobiles in Nigeria preserved at the Jos Museum.",
    featured: true,
  },
  {
    id: "mus-2",
    type: "image",
    category: "museum",
    group: "excursions",
    title: "Early Train & Steam Locomotive Exhibition",
    categoryLabel: "Jos Museum Tour",
    image: "/images/gallery/zoo4.jpeg",
    location: "National Museum Jos / Railway Heritage",
    date: "Cultural Heritage Tour",
    description: "Students exploring one of Nigeria's earliest steam train locomotives and historic railway coaches preserved at the Jos National Museum grounds.",
    featured: true,
  },
  {
    id: "mus-3",
    type: "video",
    category: "museum",
    group: "excursions",
    title: "Jos Museum Excursion Live Video Clip",
    categoryLabel: "Jos Museum Tour",
    image: "/images/gallery/zoo3.jpeg",
    videoSrc: "/images/gallery/zoovideo.mp4",
    location: "National Museum Jos",
    date: "Historical & Cultural Excursion",
    description: "Live video walkthrough showing BLIS students inspecting ancient Nigerian pottery, Nok terracotta artifacts, and historic transportation relics.",
    featured: true,
  },

  // -------------------------------------------------------------
  // 7. JOS YAKUBU GOWON AIRPORT TOUR
  // -------------------------------------------------------------
  {
    id: "air-1",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Yakubu Gowon Airport Field Tour",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport1.jpeg",
    location: "Yakubu Gowon Airport, Heipang, Jos",
    date: "Aviation & Career Excursion",
    description: "Scholars visiting the airport terminal to learn about aviation engineering, flight safety, air traffic control, and meteorological monitoring.",
    featured: true,
  },
  {
    id: "air-2",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Beside the Runway Operations Tour",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport2.jpeg",
    location: "Jos Airport Runway Apron",
    date: "Aviation Tour",
    description: "BLIS students standing beside the active airport runway tarmac, learning about runway markings, navigational aids, and ground operations.",
    featured: true,
  },
  {
    id: "air-3",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Aviation Security & Air Traffic Control Overview",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport3.jpeg",
    location: "Airport Control & Terminal",
    date: "Career Discovery Excursion",
    description: "Aviation personnel guiding BLIS students through passenger safety checks, luggage screening, and radar tracking technologies.",
    featured: false,
  },
  {
    id: "air-4",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Aerodynamics & Flight Dynamics Lecture",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport4.jpeg",
    location: "Jos Airport Hangar Area",
    date: "STEM Career Learning",
    description: "Instructors explaining Bernoulli's principle and aircraft design to spark early interest in piloting, aerospace engineering, and meteorology.",
    featured: false,
  },
  {
    id: "air-5",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Baggage Logistics & Ground Transport Systems",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport5.jpeg",
    location: "Jos Airport Cargo & Baggage Bay",
    date: "Logistics Field Trip",
    description: "Students inspecting sorting conveyors and logistics infrastructure that keep regional air transit operating efficiently.",
    featured: false,
  },
  {
    id: "air-6",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Airport Emergency & Fire Rescue Facility",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport6.jpeg",
    location: "FAAN Fire & Rescue Station, Jos",
    date: "Safety & Emergency Response",
    description: "Tour of specialized airfield crash tenders and rapid-response equipment, teaching civic duty and emergency readiness.",
    featured: false,
  },
  {
    id: "air-7",
    type: "image",
    category: "airport",
    group: "excursions",
    title: "Future Aviators Group Commemoration",
    categoryLabel: "Jos Airport Visit",
    image: "/images/gallery/airport7.jpeg",
    location: "Yakubu Gowon Airport Forecourt",
    date: "Aviation Excursion Commemoration",
    description: "Commemorative group portrait of students inspired to pursue careers as pilots, aeronautical engineers, and air traffic controllers.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 8. USA SUPPORTER VISIT
  // -------------------------------------------------------------
  {
    id: "sup-1",
    type: "image",
    category: "supporter",
    group: "partners",
    title: "Welcome Reception for USA Supporter & Partner",
    categoryLabel: "USA Supporter Visit",
    image: "/images/gallery/suppoter1.jpeg",
    location: "BLIS Main Campus, Jos",
    date: "International Partner Visit",
    description: "Rev. Fidelis Gambo, faculty, and excited scholars warmly welcoming our international partner from the United States to the school.",
    featured: true,
  },
  {
    id: "sup-2",
    type: "image",
    category: "supporter",
    group: "partners",
    title: "Picture with USA Supporter",
    categoryLabel: "USA Supporter Visit",
    image: "/images/gallery/suppoter2.jpeg",
    location: "BLIS Primary Classroom",
    date: "Partner Interaction",
    description: "Scholars and teachers taking a commemorative photograph with our USA supporter in the classroom during their inspection tour.",
    featured: true,
  },
  {
    id: "sup-3",
    type: "image",
    category: "supporter",
    group: "partners",
    title: "Academic Tour & Campus Inspection",
    categoryLabel: "USA Supporter Visit",
    image: "/images/gallery/suppoter3.jpeg",
    location: "BLIS Smart Campus Facilities",
    date: "Campus Facilities Review",
    description: "Visiting classroom suites, library books, and science learning materials to evaluate ongoing support and future development programs.",
    featured: false,
  },
  {
    id: "sup-4",
    type: "image",
    category: "supporter",
    group: "partners",
    title: "Prayers & Pastoral Blessing for Scholars",
    categoryLabel: "USA Supporter Visit",
    image: "/images/gallery/suppoter4.jpeg",
    location: "BLIS Assembly Grounds",
    date: "Partner Fellowship",
    description: "Joining hearts in prayer with management and students, dedicating the academic session to God for excellence and protection.",
    featured: false,
  },
  {
    id: "sup-5",
    type: "image",
    category: "supporter",
    group: "partners",
    title: "Strategic Planning with Management & Board",
    categoryLabel: "USA Supporter Visit",
    image: "/images/gallery/suppoter5.jpeg",
    location: "Executive Boardroom",
    date: "Mission Partnership Planning",
    description: "Rev. Fidelis Gambo and school directors strategizing on curriculum enhancements, scholarship funding, and infrastructure expansion.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 9. SCHOLARSHIPS & MOTHER MINISTRY (BLGM)
  // -------------------------------------------------------------
  {
    id: "sch-1",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Presenting Scholarship Award",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship1.jpeg",
    location: "BLIS Assembly Hall",
    date: "Annual Scholarship Award Day",
    description: "Rev. Fidelis Gambo presenting official scholarship award certificates and tuition grants to deserving scholars from vulnerable backgrounds.",
    featured: true,
  },
  {
    id: "sch-2",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Beneficiaries Students",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship2.jpeg",
    location: "BLIS Campus",
    date: "Beneficiary Milestone",
    description: "Beneficiary scholars gathered together in celebration of tuition-free Christian education made possible through ministry donors.",
    featured: true,
  },
  {
    id: "sch-3",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Sponsors Meeting Beneficiary Families",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship3.jpeg",
    location: "BLIS Fellowship Grounds",
    date: "Sponsor Fellowship",
    description: "Heartfelt meeting between generous scholarship sponsors and the families and students whose academic journeys are being supported.",
    featured: false,
  },
  {
    id: "sch-4",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Parents of the Beneficiaries",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship4.jpeg",
    location: "BLIS Community Center",
    date: "Family Outreach",
    description: "Parents and guardians of scholarship beneficiaries expressing deep appreciation for the financial relief and academic hope given to their children.",
    featured: false,
  },
  {
    id: "sch-5",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Presenting Scholarship Award & Learning Kits",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship5.jpeg",
    location: "BLIS Assembly Grounds",
    date: "Awards Ceremony",
    description: "Handing over complete sets of school uniforms, notebooks, textbooks, and termly scholarship documentation to young learners.",
    featured: false,
  },
  {
    id: "sch-6",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Orphan & Vulnerable Child Educational Sponsorship",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship6.jpeg",
    location: "Brighter Land Global Mission Center",
    date: "BLGM Mission Mandate",
    description: "Living out James 1:27 by ensuring that children without biological support systems receive elite education and loving pastoral care.",
    featured: false,
  },
  {
    id: "sch-7",
    type: "image",
    category: "scholarship",
    group: "mission",
    title: "Academic Excellence Awards for Sponsored Scholars",
    categoryLabel: "Scholarship Grants",
    image: "/images/gallery/scholarship7.jpeg",
    location: "BLIS Speech & Prize Giving Day",
    date: "Academic Prize Giving",
    description: "Honoring scholarship recipients who achieved top percentile rankings in common entrance, internal exams, and character assessments.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 10. CLEAN WATER COMMUNITY BOREHOLES (BLGM)
  // -------------------------------------------------------------
  {
    id: "bor-1",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Solar-Powered Community Borehole Commissioning",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole1.jpeg",
    location: "Host Community, Plateau State",
    date: "BLGM Community Project",
    description: "Rev. Fidelis Gambo and the Brighter Land Global Mission team commissioning a deep-water solar motorized borehole for rural families.",
    featured: true,
  },
  {
    id: "bor-2",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Providing Safe Potable Water to Rural Villages",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole2.jpeg",
    location: "Gura-Suga & Neighboring Settlements",
    date: "Water Sanitation Outreach",
    description: "Eliminating water-borne diseases by providing free, clean, and reliable running water to hundreds of community members daily.",
    featured: true,
  },
  {
    id: "bor-3",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Community Thanksgiving at Water Point",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole3.jpeg",
    location: "Plateau Rural Mission Field",
    date: "Community Dedication",
    description: "Joyful villagers, women, and children gathering at the fresh water outlet in heartfelt thanksgiving for God's provision through BLGM.",
    featured: false,
  },
  {
    id: "bor-4",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Sustainable Solar Pumping & Water Storage System",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole4.jpeg",
    location: "BLIS & Surrounding Community",
    date: "Infrastructure Development",
    description: "High-capacity overhead storage tanks and solar panel arrays ensuring round-the-clock water availability without grid failure.",
    featured: false,
  },
  {
    id: "bor-5",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Hygiene & Sanitation Education for Children",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole5.jpeg",
    location: "BLGM Health & Water Outreach",
    date: "Health Sensitization",
    description: "Teaching community children good handwashing hygiene, clean container storage, and sanitation practices alongside water provision.",
    featured: false,
  },
  {
    id: "bor-6",
    type: "image",
    category: "borehole",
    group: "mission",
    title: "Borehole Dedication Prayer with Community Elders",
    categoryLabel: "Clean Water Boreholes",
    image: "/images/gallery/borehole6.jpeg",
    location: "Village Head Compound, Jos",
    date: "Ecumenical Mission Blessing",
    description: "Pastoral leadership praying with village heads, sealing partnerships that bring peace, unity, and holistic development to the land.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 11. SCHOOL RELIEF DONATIONS & MISSION (BLGM)
  // -------------------------------------------------------------
  {
    id: "don-1",
    type: "image",
    category: "donations",
    group: "mission",
    title: "Mobile School Donation",
    categoryLabel: "School Relief Donations",
    image: "/images/gallery/donation1.jpeg",
    location: "Underserved Rural Communities, Plateau",
    date: "BLGM Relief Mission",
    description: "Distributing brand-new school uniforms, shoes, textbooks, and essential learning materials directly to children in need.",
    featured: true,
  },
  {
    id: "don-2",
    type: "image",
    category: "donations",
    group: "mission",
    title: "Textbook & Stationery Care Packages",
    categoryLabel: "School Relief Donations",
    image: "/images/gallery/donation2.jpeg",
    location: "Mission Support Centers",
    date: "Educational Supplies Relief",
    description: "Equipping young learners with government-approved NERDC curriculum textbooks, notebooks, geometry sets, and writing materials.",
    featured: false,
  },
  {
    id: "don-3",
    type: "image",
    category: "donations",
    group: "mission",
    title: "Community Outreach & Relief Intervention",
    categoryLabel: "School Relief Donations",
    image: "/images/gallery/donation3.jpeg",
    location: "IDP & Conflict-Affected Clusters",
    date: "Compassion Relief",
    description: "Delivering school bags, educational kits, and food relief to children and families displaced by regional conflicts in Plateau State.",
    featured: true,
  },
  {
    id: "don-4",
    type: "image",
    category: "donations",
    group: "mission",
    title: "Empowering Rural Schools & Volunteer Teachers",
    categoryLabel: "School Relief Donations",
    image: "/images/gallery/donation4.jpeg",
    location: "Grassroots Partner Schools",
    date: "Teacher Empowerment Mission",
    description: "Brighter Land Global Mission donating whiteboards, markers, lesson registers, and teaching aids to underfunded rural educators.",
    featured: false,
  },
  {
    id: "don-5",
    type: "image",
    category: "donations",
    group: "mission",
    title: "Community Thanksgiving & Relief Distribution",
    categoryLabel: "School Relief Donations",
    image: "/images/gallery/donation5.jpeg",
    location: "BLGM Outreach Grounds",
    date: "Mission Celebration",
    description: "A joyful gathering celebrating community resilience and the transformative love of Christ expressed through educational gifts.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 12. CONDUCIVE CLASSROOMS & ACADEMICS
  // -------------------------------------------------------------
  {
    id: "acad-1",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Attentive Classroom Learning & Inquiry",
    categoryLabel: "Conducive Classrooms",
    image: "/images/more/students learning.jpeg",
    location: "BLIS Main Classrooms",
    date: "Academic Session",
    description: "Scholars engaged in structured classroom lessons, fostering deep literacy, mathematical reasoning, and critical thinking.",
    featured: true,
  },
  {
    id: "acad-2",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Bright & Conducive Learning Environment",
    categoryLabel: "Conducive Classrooms",
    image: "/images/more/condusive learning environment.jpeg",
    location: "BLIS Academic Suites",
    date: "Campus Facilities",
    description: "Well-ventilated, secure, and fully equipped classrooms engineered to maximize concentration and academic success.",
    featured: true,
  },
  {
    id: "acad-3",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Interactive Teacher-Student Instruction",
    categoryLabel: "Conducive Classrooms",
    image: "/images/more/condusive learning environment2.jpeg",
    location: "Primary Division",
    date: "Active Instruction",
    description: "Low student-to-teacher ratio ensuring personalized academic mentorship and character development for every child.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 13. SCHOOL PROGRAMS & ASSEMBLIES
  // -------------------------------------------------------------
  {
    id: "prog-1",
    type: "image",
    category: "academics",
    group: "campus",
    title: "School Assembly & Special Program Presentation",
    categoryLabel: "School Programs",
    image: "/images/more/school program.jpeg",
    location: "BLIS Assembly Grounds",
    date: "School Program",
    description: "Scholars gathered for morning devotion, national anthem, and character-building moral exhortations.",
    featured: false,
  },
  {
    id: "prog-2",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Scholars Performing at Academic Celebration",
    categoryLabel: "School Programs",
    image: "/images/more/school program2.jpeg",
    location: "BLIS Main Stage",
    date: "School Ceremony",
    description: "Students reciting poetry, biblical verses, and musical presentations during an end-of-term celebration.",
    featured: false,
  },
  {
    id: "prog-3",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Moral Guidance & Assembly Exhortation",
    categoryLabel: "School Programs",
    image: "/images/more/school program3.jpeg",
    location: "BLIS Courtyard",
    date: "School Assembly",
    description: "Educators and pastoral leaders instilling integrity, humility, and godly leadership principles in young scholars.",
    featured: false,
  },

  // -------------------------------------------------------------
  // 14. PIONEERING FACULTY & TRAINING
  // -------------------------------------------------------------
  {
    id: "pion-1",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Pioneering NYSC Corps Members & Educators",
    categoryLabel: "Foundational Educators",
    image: "/images/more/Pioneering Corp members.jpeg",
    location: "BLIS Campus, Gura-Suga, Jos",
    date: "Pioneering Service Year",
    description: "National Youth Service Corps (NYSC) members and foundational teachers who dedicated their national service year to teaching the earliest classes at BLIS.",
    featured: true,
  },
  {
    id: "train-1",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Educator Professional Development Workshop",
    categoryLabel: "Teacher Training",
    image: "/images/gallery/teachers-training.jpeg",
    location: "BLIS ICT Training Hall",
    date: "Faculty Development",
    description: "Regular capacity-building sessions equipping BLIS instructors with modern digital pedagogy and child-centered teaching methods.",
    featured: false,
  },
  {
    id: "train-2",
    type: "image",
    category: "academics",
    group: "campus",
    title: "Pastoral Care & Classroom Excellence Training",
    categoryLabel: "Teacher Training",
    image: "/images/gallery/teachers-training2.jpeg",
    location: "BLIS Staff Suite",
    date: "Faculty Development",
    description: "Training educators to blend academic rigor with compassionate Christian mentorship for every scholar.",
    featured: false,
  },
]

// Impact Highlights for Counter & Showcase
export const impactStats = [
  { id: 1, number: "5+", label: "Major Excursions & Safari Tours", sub: "Zoo, Airport, Museum & Wildlife Park", icon: "fas fa-bus" },
  { id: 2, number: "75+", label: "Scholarships & Grants Awarded", sub: "For orphans, missionary & indigent scholars", icon: "fas fa-graduation-cap" },
  { id: 3, number: "100%", label: "Clean Water Community Boreholes", sub: "Donated to rural Plateau settlements by BLGM", icon: "fas fa-tint" },
  { id: 4, number: "1,500+", label: "School Bags & Kits Distributed", sub: "Through BLGM grassroots educational relief", icon: "fas fa-shopping-bag" },
]

// Documentary & Interview Videos
export const missionVideos = {
  founderInterview: {
    title: "The Genesis & Mandate of Brighter Land",
    subtitle: "Interview with Rev. Fidelis Gambo • Founder & Proprietor",
    src: "/images/gallery/mission.mp4",
    poster: "/images/proprietor.png",
    duration: "Full Documentary",
    description: "Rev. Fidelis Gambo shares the divine vision behind Brighter Land Global Mission, how compassion for vulnerable children inspired the founding of Brighter Land International School, and the continuing mandate to transform lives across Plateau State and Nigeria.",
    takeaways: [
      {
        title: "The Divine Mandate",
        desc: "How the Brighter Land Global Mission was birthed to take the Gospel and practical social compassion into underserved communities.",
      },
      {
        title: "Birthing the School (BLIS)",
        desc: "Establishing a premier center of academic excellence and Christian virtues in Jos to nurture children from Crèche to Secondary.",
      },
      {
        title: "Reaching the Vulnerable",
        desc: "A steadfast commitment to scholarships for orphans, missionary children, and conflict-affected families.",
      },
      {
        title: "Community Boreholes & Relief",
        desc: "Extending Christ's love through clean water boreholes, school supply donations, and teacher empowerment.",
      },
    ],
  },
  museumTour: {
    title: "Scholars Tour: Jos National Museum & Heritage",
    src: "/images/gallery/zoovideo.mp4",
    poster: "/images/gallery/zoo3.jpeg",
    description: "Live clips of BLIS scholars exploring historical artifacts, ancient steam locomotives, and Nigeria's earliest cars at the Jos Museum.",
  },
}
